import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const CartIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.5 2a.5.5 0 0 0 0 1h1.577a.25.25 0 0 1 .24.181l.914 3.196a.511.511 0 0 0 .006.021l2.471 8.651A2 2 0 0 0 8.631 16.5h8.988a2 2 0 0 0 1.923-1.45l2.474-8.663a.5.5 0 0 0-.48-.637H5.09L4.28 2.907A1.25 1.25 0 0 0 3.077 2H1.5Zm6.17 12.775L5.377 6.75h15.496l-2.293 8.025a1 1 0 0 1-.961.725H8.63a1 1 0 0 1-.961-.725Zm2.08 4.975a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm9.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
    </svg>
  );
};
